import { render } from "./FontAwesomeIcon.vue?vue&type=template&id=766320b4&scoped=true"
import script from "./FontAwesomeIcon.vue?vue&type=script&lang=js"
export * from "./FontAwesomeIcon.vue?vue&type=script&lang=js"

import "./FontAwesomeIcon.vue?vue&type=style&index=0&id=766320b4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-766320b4"

export default script